module.exports = __webpack_public_path__ + "static/img/KYC-Upload.694a173.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/backoffice/KYC-Upload.png
// module id = +oBC
// module chunks = 0